import {resource} from '@albert-io/json-api-framework/request/builder';
import masqueradeStore from 'client/generic/Masquerade/Masquerade.store';

/**
 * The classes an assignment is assigned to that the acting teacher actually teaches — the
 * masqueraded teacher's while masquerading.
 *
 * Read as a primary resource rather than as an include on the assignment: the include layer is
 * all-or-nothing and 403s the whole request when a single class is unreadable (a co-teacher, or a
 * teacher whose classes span schools), whereas "this teacher's classrooms" filters to what the actor
 * may read. Status is deliberately unfiltered — an archived class still holds students and is still
 * affected by a release.
 *
 * Shared so the submission viewer's student switcher and the release modal resolve the same actor
 * and the same classes; two copies of this would let them drift apart.
 *
 * Built per call rather than hoisted, so a masquerade switch is picked up.
 */
export const getTeacherAssignmentClassroomsQuery = (assignmentId: string) =>
  resource('classrooms_v1')
    .mandarkEndpoint(['teachers_v1', masqueradeStore.getUserIdByMasqueradeState(), 'classrooms_v1'])
    .filter({assignments_v3: assignmentId})
    .sort('name')
    .pageSize(100);
